import { Component } from '@angular/core';
import { UnderConstructionComponent } from '../shared/components/under-construction/under-construction.component';

@Component({
    selector: 'app-pilot-trade',
    templateUrl: './pilot-trade.component.html',
    styleUrl: './pilot-trade.component.scss',
    standalone: true,
    imports: [UnderConstructionComponent]
})
export class PilotTradeComponent {
}
